import React, { FC, useCallback } from 'react';

import { cleanPlayingParams } from '../feature-player/utils/clean-playing-params';
import { errorMap } from '../error-boundary-context/error-map/map';
import { ErrorBondaryContext } from '../error-boundary-context/component';
import { usePlayingContentIdVar } from '../player-manager/hooks/use-playing-content-id-var';
import { useStopPlayingContent } from '../player-manager/helpers/stop-playing-content';

import { useStopPlayingContentOnPageChange } from './hooks/use-stop-playing-content-on-page-change';
import { useStartOrStopPlayingContentOnQueryParamsChange } from './hooks/use-start-or-stop-playing-content-on-query-params-change';
import { PlayerManagerComponent } from './PlayerManagerComponent';

export const PlayerManager: FC = () => {
    const playingContentId = usePlayingContentIdVar();

    const stopPlayingContent = useStopPlayingContent();

    const stopContent = useCallback(() => {
        cleanPlayingParams();
        stopPlayingContent();
    }, [stopPlayingContent]);

    useStartOrStopPlayingContentOnQueryParamsChange();
    useStopPlayingContentOnPageChange();

    return (
        <ErrorBondaryContext errorMap={errorMap}>
            <PlayerManagerComponent playingContentId={playingContentId} stopContent={stopContent} />
        </ErrorBondaryContext>
    );
};
